/**
 * @author isi-template
 */
export const cuentaRouteMap = {
  cuenta: '/cuenta/perfil',
  configuracion: '/cuenta/configuracion',
}
